// extracted by css-extract-rspack-plugin
var _1 = "juH1BJKpjjwpjASF4hOwow--";
export { _1 as "permissionsSection" }
